import React from 'react';
import { Button, Card, Input } from 'antd';

export default function OrderActionBar(props) {
    const {
        order,
        note,
        onNoteChange,
        onSaveNote,
        onSaveDraft,
        onConfirm,
        onCancel,
        saving,
        canEdit,
        canConfirm,
        canCancel,
        isReadOnly
    } = props;

    return (
        <Card title="Thao tác đơn hàng">
            {isReadOnly ? <div style={{ marginBottom: 12 }}>Read-only</div> : null}
            <Input.TextArea rows={4} value={note} onChange={(e) => onNoteChange(e.target.value)} placeholder="Ghi chú nội bộ" />
            <div className="d-flex" style={{ gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
                <Button onClick={onSaveNote} loading={saving}>Lưu note</Button>
                {canEdit && order.status === 'draft' ? <Button onClick={onSaveDraft} loading={saving}>Lưu draft</Button> : null}
                {canConfirm ? <Button type="primary" onClick={onConfirm} loading={saving}>Xác nhận đơn</Button> : null}
                {canCancel ? <Button danger onClick={onCancel} loading={saving}>Hủy đơn</Button> : null}
            </div>
        </Card>
    );
}
